import { useState } from "react"
import { useGroupImages } from "../api/queries"
import { staticFileUrl } from "../api/http"

const MAIN_PHOTO = 1

/** Список групп не отдаёт картинки — их приходится добирать по группе.
 *  Запрос уходит только для строк текущей страницы, ответы кэширует react-query. */
export default function GroupThumb({ groupId }: { groupId: string }) {
	const { data, isLoading } = useGroupImages(groupId)
	const [broken, setBroken] = useState(false)

	if (isLoading) {
		return <div className="thumb skeleton" />
	}

	const image =
		data?.find(item => item.typeId === MAIN_PHOTO) ??
		data?.find(item => !!item.imageUrl)

	// Файла может не быть на диске, даже когда запись о нём есть в базе
	if (!image?.imageUrl || broken) {
		return (
			<div
				className="thumb thumb--empty"
				title={broken ? "Файл не найден" : "Нет фото"}
			>
				⌀
			</div>
		)
	}

	return (
		<img
			className="thumb"
			src={staticFileUrl(image.imageUrl)}
			alt=""
			loading="lazy"
			onError={() => setBroken(true)}
		/>
	)
}
